import { render, staticRenderFns } from "./VetList.vue?vue&type=template&id=66aa34a2&"
import script from "./VetList.vue?vue&type=script&lang=js&"
export * from "./VetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports